const sendMessageTemplate = `
<div class="ui-notification">
  <h3>{{header}}</h3>
  <div class="message">
    {{msg}} 
  </div>
</div>
`;

export default sendMessageTemplate;



// WEBPACK FOOTER //
// ./client/app/common/templates/notification/sendMessageTemplate.js